import { analytics } from "./index";

// One delegated click listener for the whole app. Any element can be tracked by markup only:
//   <button data-track="buy_ticket" data-track-product-id="123">Buy</button>
// sends ui_click { element_id: "buy_ticket", element_type: "button", product_id: "123", ... }.
// Never put names, emails or other personal data in data-track attributes.
const toSnake = (s) => s.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);

export function installClickTracker() {
  if (typeof document === "undefined" || window.__otaClickTrackerInstalled) return;
  window.__otaClickTrackerInstalled = true;
  document.addEventListener(
    "click",
    (e) => {
      const el = e.target?.closest?.("[data-track]");
      if (!el) return;
      const params = {
        element_type: el.tagName === "A" ? "link" : el.tagName === "BUTTON" ? "button" : el.getAttribute("role") || "element",
      };
      for (const [key, value] of Object.entries(el.dataset)) {
        if (key.startsWith("track") && key !== "track") {
          const name = toSnake(key.slice(5)).replace(/^_/, "");
          if (name) params[name] = value;
        }
      }
      analytics.trackClick(el.dataset.track, params);
    },
    true,
  );
}
